const colorTokens: any = {
  primary: {
    '300': '#e1f3ff',
    '500': '#00519f',
    '700': '#034585'
  },
  secondary: {
    '200': '#ffefeb',
    '400': '#f76659',
    '500': '#ff3c12',
    '700': '#e7310a'
  },
  gray: {
    '0': '#ffffff',
    '100': '#edeff0',
    '400': '#9aa6ac',
    '600': '#484a4e',
    '900': '#04192e',
    '999': '#000000'
  },
};

colorTokens.aliases = {};
colorTokens.aliases.text = colorTokens.gray['900'];
colorTokens.aliases.textLight = colorTokens.gray['600'];
colorTokens.aliases.bodyBackground = colorTokens.gray['100'];
colorTokens.aliases.link = colorTokens.primary['500'];

export default colorTokens;
